import { getSettingQuery } from 'dataLayer/user'
import { Container } from 'react-bootstrap'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

function SettingPage() {
	const { type } = useParams()
	const { data: helpData } = useQuery(getSettingQuery())
	const HTML = (helpData && helpData.find(it => it.type === type)) || ''
	return (
		<Container fluid className="setting-container">
			<div
				className="setting-content"
				dangerouslySetInnerHTML={{ __html: HTML.content }}
			/>
		</Container>
	)
}

export default SettingPage
